var DesignBoardTemplates = require('./design-board-templates.js');
var DesignBoardHelpers = require('./design-board-helpers.js');

module.exports = {
	updateBoard : function( parentEl, boardId, itemsToSave, boardNameVal, evt ){
       
        var $document = $(document);
        var boardName = boardNameVal,        
        data = {},
        itemsToSaveOnBoard = itemsToSave;

        $document.trigger('board:updated', this);
        if ( evt ){
            evt.preventDefault();
        }

        if ( !boardNameVal ){
            var selectedItems = $('.DesignBoard-grid-item-edit').not( '.DesignBoard-item-selected' );

            boardName = $( parentEl ).find( '.form-control' ).val();
            itemsToSaveOnBoard = DesignBoardHelpers.transformElementsToItems( selectedItems );
        }
        data = {
            "Id": boardId,
            "Name": boardName,
            "DesignBoardItems": itemsToSaveOnBoard
        };

        DesignBoardHelpers.showLoading();

        $.ajax({
            url: '/api/designboard/'+boardId,
            data: data,
            method: "PUT",
            dataType: "json", 
            cache: false
        })
        .fail( function(){
            DesignBoardHelpers.hideLoading();
            //TODO: show error message, to be defined
        })
        .done( function(){
            if ( !boardNameVal ){
                DesignBoardHelpers.enterToDetailMode( boardId );
            }
            else {
                DesignBoardHelpers.hideLoading();
            }

        });
    },

    deleteBoard : function( boardId, urlToGo, evt ){
        evt.preventDefault();
        DesignBoardHelpers.showLoading();

        $.ajax({
            url: '/api/designboard/'+boardId,
            method: "DELETE",
            cache: false
        })
        .fail( function(){
            DesignBoardHelpers.hideLoading();
            window.location.href = urlToGo;
        })
        .done( function(){
            window.location.href = urlToGo;
        });

    },

    saveBoard: function (parentEl, evt) {
        evt.preventDefault();
        DesignBoardHelpers.showLoading();
    
        var boardName = $(parentEl).find('.DesignBoard-input-wrapper .text').val();
        var errorEl = $('.DesignBoardWrapper').find('.MsgModal--error');
        var $createDesignBoardform = $('.Form-DesignBoard-create');
    
        var formData = $createDesignBoardform.serialize();
        var token = $createDesignBoardform.find('input[name="__RequestVerificationToken"]').val();
    
        if (!token) {
            console.error('CSRF token not found in form. Aborting request.');
            DesignBoardHelpers.hideLoading();
            errorEl.text('Unable to submit. Security token missing.').show();
            return;
        }
    
        formData += '&Name=' + encodeURIComponent(boardName);
    
        $.ajax({
            url: '/api/designboard/',
            data: formData,
            method: "POST",
            dataType: "json",
            cache: false
        })
        .fail(function () {
            errorEl.show();
            DesignBoardHelpers.hideLoading();
        })
        .done(function (response) {
            DesignBoardHelpers.hideLoading();
            $(parentEl).trigger('enterToAddMode', response.result.id);
            $(parentEl).attr('data-id', response.result.id);
        });
    },
    
    
    addItemsBoard: function (boardId) {
        var $editDesignBoardform = $('.Form-DesignBoard-edit');
        var itemsToAdd = $('.DesignBoard-grid-item-edit.DesignBoard-item-selected');
        var itemsToAddObj = DesignBoardHelpers.transformElementsToItems(itemsToAdd);
        var errorEl = $('.DesignBoardWrapper').find('.MsgModal--error');
    
        if (!boardId) {
            boardId = $(this.element).data('id');
        }
    
        var token = $editDesignBoardform.find('input[name="__RequestVerificationToken"]').val();
    
        if (!token) {
            console.error('CSRF token not found in form. Aborting request.');
            DesignBoardHelpers.hideLoading();
            errorEl.text('Unable to submit. Security token missing.').show();
            return;
        }
    
        var formData = $editDesignBoardform.serialize();
    
        // Append additional data to formData
        formData += '&Id=' + encodeURIComponent(boardId);
        formData += '&' + $.param({ DesignBoardItems: itemsToAddObj });
    
        DesignBoardHelpers.showLoading();
    
        $.ajax({
            url: '/api/DesignBoardItem/' + boardId,
            data: formData,
            method: "POST",
            dataType: "json",
            cache: false
        })
        .fail(function () {
            errorEl.text('An error occurred while adding items.').show();
            DesignBoardHelpers.hideLoading();
        })
        .done(function (response) {
            DesignBoardHelpers.hideLoading();
            DesignBoardHelpers.enterToDetailMode(boardId);
        });
    },
    

    loadAllItems: function( wrapperEl, firstLoad, boardId, evt ){
        var itemsWrapperEl = wrapperEl.find( '.DesignBoard-grid-list' ),
            filterWrapperEl = wrapperEl.find( '.Filter' ),
            valueWrapper = filterWrapperEl.find( '.FilterButton-value' ),
            itemType = DesignBoardHelpers.itemsTypes.homes,
            currentBoardId = boardId,
            modalItems = {},
            itemsWrapperPerType = {},
            valueText = '',
            valueData = '',
            itemsContent = '';
            
        evt.preventDefault();
        if ( !firstLoad ){
            valueText = $( evt.target ).text().trim();
            valueData = $( evt.target ).data( 'filter' );
            valueWrapper.text( valueText );
            itemType = valueData;
            filterWrapperEl.removeClass( 'is-open' );
        }
        if ( !currentBoardId ){
            currentBoardId = $( this.element ).data( 'id' );
        }
        itemsWrapperEl.removeClass( 'item-active' );
        itemsWrapperPerType = $( '.DesignBoard-grid-list-'+itemType );
        if ( itemsWrapperPerType.html().trim() === '' ){
            DesignBoardHelpers.showLoading();
            $.ajax({
                url: '/api/designboard/saveditems?tooltype='+itemType+'&id='+currentBoardId,
                method: "GET",
                dataType: "json",
                cache: false
            })
            .fail( function(){
                DesignBoardHelpers.hideLoading();
                //TODO: show error message, to be defined
            })
            .done( function( response ){
                itemsWrapperPerType.addClass( 'item-active' );

                itemsContent = DesignBoardTemplates.populateEditPage( response );
                itemsWrapperPerType.html( itemsContent );
                modalItems = $( wrapperEl ).find( '.DesignBoard-grid-item' );
                DesignBoardHelpers.onSelectItemsEvent( modalItems, 'fromAddItems' );
                DesignBoardHelpers.hideLoading();
            });
        }
        else{
            modalItems = $( wrapperEl ).find( '.DesignBoard-grid-item' );
            DesignBoardHelpers.onSelectItemsEvent( modalItems, 'fromAddItems' );
            itemsWrapperPerType.addClass( 'item-active' );
        }
    }
}
